export default __webpack_public_path__ + "static/media/somethingwrong-3.bd07bd16.png";